<h2 mat-dialog-title>Raw payload</h2>

<mat-dialog-content>
    <p class="target"><b>{{ data.title }}</b></p>
    <pre class="payload">{{ data.rawPayload }}</pre>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button type="button" mat-button (click)="close()">Close</button>
</mat-dialog-actions>
